module.exports = __webpack_public_path__ + "img/face8.7e38a61a.gif";